module.exports = __webpack_public_path__ + "img/bank.a299258a.png";